import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=bc488db4&"
import script from "./Asset.vue?vue&type=script&lang=js&"
export * from "./Asset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/casperjureskog/CMM/creo-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc488db4')) {
      api.createRecord('bc488db4', component.options)
    } else {
      api.reload('bc488db4', component.options)
    }
    module.hot.accept("./Asset.vue?vue&type=template&id=bc488db4&", function () {
      api.rerender('bc488db4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Asset.vue"
export default component.exports